import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import streetReadAction from './streetRead.action.json' with { type: 'json' }

const streetReadDefinition = defineReadAutoAction(streetReadAction, 'street')

export default streetReadDefinition
